




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppUserFilter, RightEnum, StSelectListItem } from '@/services/api/nswag/stapiclient_generated';
import { stAppUserApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';

@Component({
  components: {},
})
export default class UserSelect extends Vue {
  @Prop() value!: number;
  @Prop() rightEnum!: RightEnum;
  @Prop() noPadding!: boolean;
  users: StSelectListItem[] = [];

  async mounted() {
    await this.loadUsers();
  }

  get isDifferentUser() {
    return this.selectedUserId != UserStore.currentUser.id;
  }

  get selectedUserId() {
    return this.value;
  }

  set selectedUserId(id: number) {
    this.$emit('input', id);
  }

  get canEditTimeEntriesForEmployees() {
    return UserStore.userSettings[this.rightEnum];
  }

  resetUser() {
    this.selectedUserId = UserStore.currentUser.id!;
  }

  async loadUsers() {
    if (this.canEditTimeEntriesForEmployees) {
      this.users = (await stAppUserApi.getList(AppUserFilter.fromJS({ isArchived: false }))).map((_) => {
        const item = new StSelectListItem();
        item.id = _.id;
        item.description = _.name;
        return item;
      });
    }
  }
}
